"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = void 0;
var errors_1 = require("@devexpress/utils/lib/errors");
var list_1 = require("@devexpress/utils/lib/utils/list");
var Columns = (function () {
    function Columns(intervalsInfo) {
        this.width = list_1.ListUtils.map(intervalsInfo, function (curr) { return curr.width; });
        this.numColumns = this.width.length;
        var pos = 0;
        this.positions = list_1.ListUtils.map(intervalsInfo, function (curr) { return pos += curr.width; });
        this.positions.unshift(0);
        if (list_1.ListUtils.unsafeAnyOf(this.positions, function (p) { return isNaN(p) || p < 0; }))
            throw new Error(errors_1.Errors.InternalException);
    }
    return Columns;
}());
exports.Columns = Columns;
